import React, { useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { recover } from "../../store/actions/homeActions";
import { Link } from "react-router-dom";

import { useHistory } from 'react-router-dom';


function Recovery(props) {
  const { recoverFN, errore, recovered } = props;
  const [username, setusername] = useState(null);

  const history = useHistory();


  const handleSubmit = (e) => {
    e.preventDefault();
   /* recoverFN(
      username,
    );*/

    history.push("/login");

  };


  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="w-full max-w-md">
        {/* Back to Login Link */}
        <Link
          to="/login"
          className="flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-6 transition-colors"
        >
          <i className="fas fa-arrow-left"></i>
          <span>Back to Login</span>
        </Link>

        {/* Card */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Top Section - Dark Blue Header */}
          <div className="bg-gradient-to-r from-slate-600 to-slate-700 px-8 py-10 text-center">
            <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="far fa-envelope text-white text-2xl"></i>
            </div>
            <h1 className="text-white mb-2 text-2xl font-bold">
              Reset Your Password
            </h1>
            <p className="text-slate-200 text-sm">
              Enter your email and we'll send you reset instructions
            </p>
          </div>

          {/* Bottom Section - White Form */}
          <div className="px-8 pt-6 pb-8">
            <form onSubmit={handleSubmit}>
              {/* Email Address Field */}
              <div className="mb-4">
                <label htmlFor="username" className="block text-gray-700 text-sm font-medium mb-2">
                  Email Address
                </label>
                <div className="relative">
                  <input
                    required
                    className="block w-full p-3 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400"
                    type="text"
                    placeholder="you@example.com"
                    id="username"
                    name="username"
                    onChange={(v) => {
                      setusername(v.target.value);
                    }}
                    value={username || ""}
                  />
                  <span className="absolute left-3 top-3.5 text-gray-500">
                    <i className="far fa-envelope"></i>
                  </span>
                </div>
                <p className="text-gray-500 text-xs mt-2">
                  We'll send a password reset link to this email address
                </p>
              </div>

              {/* Error Message */}
              {errore && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                  <p className="text-sm text-red-600">{errore}</p>
                </div>
              )}

              {/* Success Message */}
              {recovered && (
                <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg">
                  <p className="text-sm text-green-600">
                    We have sent you a new password by email! Make sure you check your spam folder.
                  </p>
                </div>
              )}

              {/* Send Reset Link Button */}
              <button
                type="submit"
                className="w-full py-3 px-6 bg-slate-600 hover:bg-slate-700 text-white font-semibold rounded-lg transition-all shadow-lg hover:shadow-xl focus:outline-none"
              >
                Send Reset Link
              </button>

              {/* Note Section */}
              <div className="mt-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
                <p className="text-xs text-gray-600">
                  <span className="font-semibold">Note:</span> For security reasons, if this email is not associated with an account, no email will be sent.
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    errore: state.auth.errore,
    recovered: state.auth.recovered,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    recoverFN: (username) =>
      dispatch(recover(username)),

  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  Recovery
);
